export const casualPageConfig = {
  "title": "Event Exploration",
  "titleCN": "事件探索",
  "path": "/eventAnalysis/eventExploration",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "isHaveNotification": true,
      "notificationPath": "/eventAnalysis/eventExploration",
      "path": "/eventAnalysis/eventExploration",
      "logConfig": {
        "pageId": "208201",
        "pageName": "Event Exploration IAA",
        "extInfo": "Event Exploration IAA",
        "pagePath": "/eventAnalysis/eventExploration"
      },
      "filters": [
        {
          "name": "EventExplorationFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": false,
          "filterPath": "/eventAnalysis/eventExploration",
          "api": "/api/v1/dashboard/pc/event/exploration/select",
          "extraSelectorParams": {
            "selector_list": []
          },
          "haveEventFilter": true,
          "haveDimensionFilter": true,
          "hoursSinceRegisterOptions": [
            {
              "value": "24",
              "text": "24"
            },
            {
              "value": "72",
              "text": "72"
            },
            {
              "value": "168",
              "text": "168"
            }
          ],
          "compEventNameSelect": {
            "selectProps": {
              "matchButtonWidth": true
            }
          },
          "defaultDimensionValue": [],
          "dimensionOptions": [
            {
              "groupKey": "separated",
              "value": "date",
              "textEn": "By Date",
              "textCn": "分日期",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "region",
              "textEn": "By Region",
              "textCn": "分区域",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "country",
              "textEn": "By Country",
              "textCn": "分国家",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "system",
              "textEn": "By Platform",
              "textCn": "分平台",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "media_source",
              "textEn": "By Media Channel",
              "textCn": "分买量渠道",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "app_version",
              "textEn": "By Version",
              "textCn": "分版本",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "network_type",
              "textEn": "By Media Channel Type",
              "textCn": "分渠道类型",
              "info": ""
            },
            {
              "groupKey": "separated",
              "value": "campaign",
              "textEn": "By Campaign",
              "textCn": "分 Campaign",
              "info": ""
            }
          ],
          "componentList": [
            {
              "name": "EventFilterRequiredWrap",
              "props": {
                "tableTitle": {
                  "titleEn": "Event Exploration",
                  "titleCn": "事件探索"
                },
                "placeholderTipsEn": "Please apply【Event Filter】 to view data.",
                "placeholderTipsCn": "筛选器设置【事件筛选】后，即可查看对应数据。"
              },
              "children": [
                {
                  "name": "MetricInfo",
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "eventAnalysis/eventExploration",
                      "componentKey": "OverviewTableCo",
                      "height": 775,
                      "data": {
                        "tableMetric": [
                          "et_new_users",
                          "et_active_users",
                          "et_new_active_ratio",
                          "et_retention_d2",
                          "et_retention_d3",
                          "et_retention_d4",
                          "et_retention_d5",
                          "et_retention_d6",
                          "et_retention_d7",
                          "et_retention_d8",
                          "et_retention_d9",
                          "et_retention_10",
                          "et_retention_d11",
                          "et_retention_d12",
                          "et_retention_d13",
                          "et_retention_d14",
                          "et_avg_interstitial_impressions",
                          "et_avg_rewarded_impressions",
                          "et_avg_banner_impressions",
                          "et_active_arpu",
                          "et_interstitial_ecpm",
                          "et_rewarded_ecpm",
                          "et_banner_ecpm"
                        ]
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
